export default __webpack_public_path__ + "static/media/Thief's Gloves of the Burning Temple.32d438b1.jpg";